import Player from '@vimeo/player';

export default function load_embeds(){
    
    const vimeoEmbeds = document.querySelectorAll('.video-embed');

    // console.log(vimeoEmbeds);
      
    const loadVideo = (vimeoContainer) => {

      const videoUrl = vimeoContainer.getAttribute('data-video-url');

        var quality = '1080p';
       
        if(vimeoContainer.classList.contains('chromless')){
            quality = '360p';
        }
      
        const player = new Player(vimeoContainer, {
            id: videoUrl,
            controls: 0,
            autoplay: false,
            playsinline:true,
            loop: true,
            muted: true,
            quality: quality,
            autopause: false,
            background: 1,
            dnt: 1,
        });


        if(player){

            var muted = 1;
            var fullscreen = 0;
            var bound = false;

            const project =  vimeoContainer.closest('.project, .project-asset');
            const embedWrap =  vimeoContainer.parentNode;
            const controls = embedWrap.querySelector('.controls');
    

            var played = false;
        
            window.players.push({
                type: 'vim',
                player: player,
                elm: embedWrap
            });

            
            if(controls){

                const sound = controls.querySelector('.sound');
                const size = controls.querySelector('.size');
                const state = controls.querySelector('.state');

                const pLeft = controls.querySelector('.play-bar-left');
                const pRight = controls.querySelector('.play-bar-right');
                const pTime = controls.querySelector('.play-time');
                const playBar = controls.querySelector('.play-bar');

   
                var videoLength = false;
                var mousedown = false;

         
                addClassOnHoverWithReset(project, 'show-controls', 2500);
                addClassOnHoverWithReset(embedWrap, 'show-controls', 2500);
         
                if(typeof sound !== 'undefined'){
                    sound.addEventListener('click', function(){
                        if(muted){
                            muteAll();
                            muted = 0;
                            player.setVolume(1);
                            embedWrap.classList.remove('muted');
                        }else{
                            muted = 1;
                            player.setVolume(0);
                            embedWrap.classList.add('muted');
                        }
                    });
                }

                if(typeof size !== 'undefined'){


                    size.addEventListener('click', function(){

                       
                        if(!window.fullscreen){
                            
                            window.fullscreen = 1;
                            
                            if(window.touch){
                                let iframe = embedWrap.querySelector('iframe');
                                goFullScreen(iframe);
                            }else{
                                goFullScreen(embedWrap);
                            }
                            

                            console.log('enter');
                          
                        }else{
                            window.fullscreen = 0;
                            exitFullScreen();
                            console.log('exit');
                        }
                    });
                    
                    player.on('fullscreenchange', function(data) {
                        if (data.fullscreen) {
                            embedWrap.classList.add('fullscreen');
                        } else {
                            embedWrap.classList.remove('fullscreen');
                        }
                    });

                }

            
                playBar.addEventListener('mousedown',function(e){
                    e.preventDefault();
                    mousedown = true;
                    playBar.classList.add('grabbing');
                    update_play_pos(e);
                });
                
                playBar.addEventListener('mouseup',function(e){
                    e.preventDefault();
                    mousedown = false;
                    playBar.classList.remove('grabbing');
                });

                playBar.addEventListener('mouseleave',function(e){
                    e.preventDefault();
                    mousedown = false;
                    playBar.classList.remove('grabbing');
                });

                playBar.addEventListener('mousemove', function(e){
                    e.preventDefault();
                    update_play_pos(e);
                });


                playBar.addEventListener('touchstart',function(e){
                    e.preventDefault();
                    mousedown = true;
                    playBar.classList.add('grabbing');
                    update_play_pos(e);
                });
                
                playBar.addEventListener('touchend',function(e){
                    e.preventDefault();
                    mousedown = false;
                    playBar.classList.remove('grabbing');
                });

                playBar.addEventListener('touchleave',function(e){
                    e.preventDefault();
                    mousedown = false;
                    playBar.classList.remove('grabbing');
                });

                playBar.addEventListener('touchmove', function(e){
                    e.preventDefault();
                    update_play_pos(e);
                });

                playBar.addEventListener('click', function(e){

                    e.preventDefault();
                    update_play_pos(e);
                    
                });

                state.addEventListener('click', function(){
                    player.getPaused().then(function(paused) {
                        if (paused) {
                        player.play();
                        } else {
                        player.pause();
                        }
                    }).catch(function(error) {
                        console.error('Error checking video state:', error);
                    });
                });

                
                player.on('play', function() {

                    played = true;

                    if(!mousedown){

                        vimeoContainer.parentNode.classList.add('playing');
                        vimeoContainer.parentNode.classList.add('embed-loaded');

                        const assetWrap = vimeoContainer.closest('.project-asset, .first-asset');
                        
                        if(assetWrap){
                            assetWrap.classList.add('loaded');
                        }
                    
                        state.innerHTML = 'Pause';
                    
                        player.getDuration().then(function(duration) {
                            
                            videoLength = duration;

                        }).catch(function(error) {
                            console.error('Error getting video duration:', error);
                        });
                    }

                });


                player.on('pause', function() {
                    if(!mousedown){
                        state.innerHTML = 'Play';
                        vimeoContainer.parentNode.classList.remove('playing');
                    }
                });

                player.on('timeupdate', function(e){
                    var per = e.percent * 100;
                    pLeft.style.setProperty("--width", per + '%');
                    pRight.style.setProperty("--width", 100-per + '%');
                    pTime.innerHTML = convertToFilmTimestamp(e.seconds);

                    vimeoContainer.dataset.time = e.seconds;
                });

                function update_play_pos(e){

                    const rect = playBar.getBoundingClientRect();
                    
                    var x = e.clientX - rect.left;

                    if(e.touches && e.touches[0]){
                        x =  e.touches[0].clientX - rect.left;
                    }
                    
                    const percentage = (x / rect.width) * 100;

                    if(mousedown && videoLength){

                        var newTime = (percentage / 100) * videoLength;
                        player.setCurrentTime(newTime);

                        pLeft.style.setProperty("--width", percentage + '%');
                        pRight.style.setProperty("--width", 100-percentage + '%');
                        pTime.innerHTML = convertToFilmTimestamp(newTime);
        
                    }
                }
            }else{
                player.on('play', function() {
                    played = true;

                    const assetWrap = vimeoContainer.closest('.project-asset, .first-asset');

                    if(assetWrap){
                        assetWrap.classList.add('loaded');
                    }

                });

                
            }

            player.on('loaded', function() {
                played = true;
            });

            const onScreen = (entries, observer) => {
                entries.forEach(entry => {
                    
                  if (entry.isIntersecting) {
                    if(played){
                        player.play();
                    }
                  }else{
                    if(played){
                        // console.log(vimeoContainer, 'paused');
                        player.pause();
                    }
                  }
                });
            };

            const screen_observer = new IntersectionObserver(onScreen, {
                rootMargin: "100px 100px",
                threshold: 0.1
            });
        
            if(!vimeoContainer.classList.contains('hover-vid')){
                screen_observer.observe(vimeoContainer);
            }


            if(vimeoContainer.classList.contains('hover-vid')){
                
                const link = vimeoContainer.closest('.project-link');

                if(link){

                    link.addEventListener('mouseenter', function(e){
                        player.play();
                    });

                    link.addEventListener('mouseleave', function(e){
                        player.pause();
                    });
                }
            }
        
        }

    };
  
    const lazyLoad = (entries, observer) => {
    
        entries.forEach(entry => {
       
            if (entry.isIntersecting) {

                const clientBox =  entry.target.closest('.client-box');
                const project =  entry.target.closest('.project-asset');
                
                if(project && clientBox){
                    
                    if(project.classList.contains('top')){
                        loadVideo(entry.target);
                        observer.unobserve(entry.target);
                    }

                }else{
                    loadVideo(entry.target);
                    observer.unobserve(entry.target);
                }

              
            }

      });

    };
  

    const observer = new IntersectionObserver(lazyLoad, {
      rootMargin: "100px 0px",
      threshold: 0.1
    });
  

    vimeoEmbeds.forEach(vimeoContainer => {
      vimeoContainer.classList.add('bound');
      observer.observe(vimeoContainer);
    });


    function check_for_new(){

        const vimeoEmbeds = document.querySelectorAll('.video-embed');

        for (let a = 0; a < vimeoEmbeds.length; a++) {
            const vimeoContainer = vimeoEmbeds[a];
            if(!vimeoContainer.classList.contains('bound')){
                vimeoContainer.classList.add('bound');
                observer.observe(vimeoContainer);
            }
            
        }

        setTimeout(function(){
            check_for_new();
        }, 1000);
    }

    setTimeout(function(){
        check_for_new();
    }, 1000);
  
};

function getCurrentTimeAndDuration(player) {
    // Get the current time of the video
    player.getCurrentTime().then(function(currentTime) {
        // Get the total duration of the video
        player.getDuration().then(function(duration) {
            // console.log('Current Time: ' + currentTime + ' seconds');
            // console.log('Total Duration: ' + duration + ' seconds');
        }).catch(function(error) {
            console.error('Error getting video duration:', error);
        });
    }).catch(function(error) {
        console.error('Error getting current time:', error);
    });
}
  

function convertToFilmTimestamp(seconds) {
    // Convert the float to total seconds
    let totalSeconds = Math.floor(seconds);
    
    // Calculate hours, minutes, and seconds
    let hours = Math.floor(totalSeconds / 3600);
    let minutes = Math.floor((totalSeconds % 3600) / 60);
    let secs = totalSeconds % 60;

    // Pad with leading zeros if necessary
    hours = String(hours).padStart(2, '0');
    minutes = String(minutes).padStart(2, '0');
    secs = String(secs).padStart(2, '0');

    // Return the formatted timestamp
    return `${hours}:${minutes}:${secs}`;
}



function addClassOnHoverWithReset(element, className, delay) {
    let timeout;

    function removeClass() {
      element.classList.remove(className);
    }

    function resetTimer() {
      element.classList.add(className);
      clearTimeout(timeout);
      timeout = setTimeout(removeClass, delay);
    }

    element.addEventListener('mouseenter', () => {
      element.classList.add(className);
      resetTimer();
    });

    element.addEventListener('mousemove', resetTimer);

    element.addEventListener('mouseleave', () => {
      clearTimeout(timeout);
      removeClass();
    });

    element.addEventListener('touchstart', () => {
        element.classList.add(className);
        resetTimer();
      });
  
      element.addEventListener('touchmove', resetTimer);
  
      element.addEventListener('touchend', () => {
        clearTimeout(timeout);
        removeClass();
      });

  }

  function muteAll(){
    
    for (let a = 0; a < window.players.length; a++) {
        const player =  window.players[a];

        if(player.type == 'vim'){
            player.player.setVolume(0);
        }else{
            player.player.volume = 0;
        }

        player.elm.classList.add('muted');
        
    }
    
  }

  function goFullScreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) { // For Safari
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) { // For IE11
      element.msRequestFullscreen();
    } else {
      console.warn('Fullscreen API is not supported in this browser.');
    }
  }

  function exitFullScreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { // For Safari
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { // For IE11
      document.msExitFullscreen();
    } else {
      console.warn('Fullscreen exit is not supported in this browser.');
    }
  }